import React from "react";
import { __ } from "services/Translator";
import { Button } from "react-bootstrap";
export default function Pagination(props) {
  const landingType = props.landingType;
  const data = props.data;
  // const __ = (text) => text;
  const currentPage =
    props.data &&
    props.data.length &&
    props.data.filter((item) => item.type === "current_page").length
      ? props.data.filter((item) => item.type === "current_page")[0].page
      : 1;

  const lastPage =
    props.data && props.data.length
      ? props.data[props.data.length - 1].page
      : 1;

  const onPageChange = (page) => {
    if (props.onPageChange && page) {
      props.onPageChange(page);
    }
  };

  const incrementPage = () => {
    if (currentPage < lastPage) {
      onPageChange(currentPage + 1);
    }
  };

  if (!data || currentPage >= lastPage) {
    return null;
  }

  return (
    <>
      <div className="container d-flex justify-content-center">
        <button
          onClick={incrementPage}
          className={"angle_btn small and_load_more " + landingType}
        >
          {__("Load More")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="red"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            />
          </svg>
        </button>
      </div>
    </>
  );
}
